import { UpperCasePipe } from "@angular/common";
import { Component } from "@angular/core";
import { CoreService } from "src/app/services/core.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-branding",
  imports: [UpperCasePipe],
  template: `
    <!-- <a href="/" class="logodark">
      <img
        src="./assets/images/logos/dark-logo.svg"
        class="align-middle m-2"
        alt="logo"
      />
    </a>


    <a href="/" class="logolight">
      <img
        src="./assets/images/logos/light-logo.svg"
        class="align-middle m-2"
        alt="logo"
      />
    </a> -->
    <div
      class="text-decoration-none d-flex justify-content-center align-items-center "
    >
      <span style="font-size: 1.3rem; font-weight:800">{{
        appName | uppercase
      }}</span>
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
  appName = environment.appName;
  constructor(private settings: CoreService) {}
}
